import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13 5.5a1 1 0 0 1-1-1V1a1 1 0 1 1 2 0v2.5h9a1 1 0 1 1 0 2zm-13 10a1 1 0 0 1 1-1h8v-5H1a1 1 0 0 1 0-2h9a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1M12 23a1 1 0 1 0 2 0v-2.5h9a1 1 0 1 0 0-2H13a1 1 0 0 0-1 1zm6.558-7.076A1 1 0 0 1 17.94 15v-2H14a1 1 0 1 1 0-2h3.94V9a1 1 0 0 1 1.707-.707l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.09.217Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const TableRowAdd = { render };
export {
  TableRowAdd as default,
  render
};
//# sourceMappingURL=TableRowAdd.svg.js.map
